import { __awaiter, __generator } from "tslib";
export function loadRollworks(analytics) {
    var _this = this;
    window.onB2BPersonalizationDataReady = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!data || ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website) || !data['domain']) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, analytics.group(null, {
                            website: data.domain,
                            intentSource: 'rollworks',
                            name: data.company_name || undefined,
                            industry: data.company_industry || undefined,
                            number_of_employees: data.company_size || undefined,
                            annual_revenue: data.company_revenue || undefined,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
//# sourceMappingURL=rollworks.js.map